/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "./ContextMenu.css";
import Separater from "./Separater";
import styled from "styled-components";
import {
  CgClose,
  CgFormatText,
  CgInfo,
  CgInsertAfter,
  CgInsertBefore,
  CgMoon,
  CgSun,
  CgZoomIn,
  CgZoomOut,
} from "react-icons/cg";

const Item = styled.button`
  border: none;
  outline: none;
  background: none;
  text-align: initial;
  padding: 6.2px 62px;
  padding-left: 8px;
  &:hover {
    background: #f7f7f7;
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

function ContextMenu(props) {
  const menuRef = useRef(null);

  function handleInsertText() {
    const data = menuRef.current.getBoundingClientRect();
    console.log(data, props.pageId);
    const offset = window.pdfDoc
      .getElementById(props.pageId)
      .getBoundingClientRect();

    const position = { x: data.x - offset.x, y: data.y - offset.y };
    props.insertText({ id: props.pageId, position });
    props.setShowMenu(false);
  }

  function handleInsertPage(vector) {
    props.onInsertPage(vector);
    props.setShowMenu(false);
  }

  function handleDeletePage() {
    if (props.totalPages < 2) {
      return;
    }
    props.onDeletePage(props.pageId);
    props.setShowMenu(false);
  }

  return (
    <div
      ref={(ref) => {
        props._ref(ref);
        menuRef.current = ref;
      }}
      className="pdf-ctx-menu--cont"
      dataopen={(!!props.open).toString()}
      onContextMenu={(e) => e.preventDefault()}
    >
      <Item onClick={handleInsertText}>
        <ItemWrapper>
          <CgFormatText /> Insert Text Here
        </ItemWrapper>
      </Item>
      <Item onClick={() => handleInsertPage(1)}>
        <ItemWrapper>
          <CgInsertAfter /> Insert Page After
        </ItemWrapper>
      </Item>
      <Item onClick={() => handleInsertPage(0)}>
        <ItemWrapper>
          <CgInsertBefore /> Insert Page Before
        </ItemWrapper>
      </Item>

      <Separater />

      {/* <Item>
        <ItemWrapper>
          <CgZoomIn /> Zoom In
        </ItemWrapper>
      </Item>

      <Item>
        <ItemWrapper>
          <CgZoomOut /> Zoom Out
        </ItemWrapper>
      </Item> */}

      <Separater />
      <Item onClick={handleDeletePage} disabled={props.totalPages < 2}>
        <ItemWrapper>
          <CgClose /> Delete This Page
        </ItemWrapper>
      </Item>

      <Separater />
      <Item>
        <ItemWrapper>
          <CgInfo /> Properties
        </ItemWrapper>
      </Item>
    </div>
  );
}

export default ContextMenu;
